<div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Departments</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a [routerLink]="[getDashboardRoute()]" href="javascript:void(0);">
              <i class="ti ti-smart-home"></i>
            </a>
          </li>
          <!-- <li class="breadcrumb-item">
              Employee
            </li> -->
          <li class="breadcrumb-item active" aria-current="page">Departments</li>
        </ol>
      </nav>
    </div>
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
      <div class="me-2 mb-2 d-none">
        <div class="dropdown">
          <a
            href="javascript:void(0);"
            class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
            data-bs-toggle="dropdown"
          >
            <i class="ti ti-file-export me-1"></i>Export
          </a>
          <ul class="dropdown-menu dropdown-menu-end p-3">
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1"
                ><i class="ti ti-file-type-pdf me-1"></i>Export as PDF</a
              >
            </li>
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1"
                ><i class="ti ti-file-type-xls me-1"></i>Export as Excel
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="mb-2" *appHasPermission="{ department: ['add'] }">
        <button
          class="btn btn-primary d-flex align-items-center"
          (click)="openBusinessModal(addBusinessModals)"
        >
          <i class="ti ti-circle-plus me-2"></i>Add Department
        </button>
      </div>
      <div class="head-icons ms-2 d-none">
        <a
          href="javascript:void(0);"
          class=""
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          data-bs-original-title="Collapse"
          id="collapse-header"
        >
          <i class="ti ti-chevrons-up"></i>
        </a>
      </div>
    </div>
  </div>
  <!-- /Breadcrumb -->

  <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
      <h5>Department List</h5>

      <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
        <div class="me-3">
          <select
            class="form-select form-select-sm col-md-1"
            id="entries"
            [(ngModel)]="pageLimit"
            (change)="onPageLimitChange()"
          >
            <!-- <option selected disabled>Show Entries Per Page</option> -->
            <option *ngFor="let limit of [10, 20, 50, 100]" [value]="limit">
              {{ limit }}
            </option>
          </select>
        </div>

        <!-- <div class="dropdown me-3">
          <select
            class="form-select"
            #businessSelect
            [(ngModel)]="businessId"
            (change)="loadDepartments(); setCurrentPage()"
          >
            <option value="" selected>Select Business Entity</option>
            <option *ngFor="let business of businesses$ | async" [value]="business.id">
              {{ business.businessName | capitalize }}
            </option>
          </select>
        </div> -->

        <ng-select
          class="me-3"
          [items]="businesses$ | async"
          bindValue="id"
          placeholder="Select Business Entity"
          [(ngModel)]="businessId"
          (change)="loadDepartments()"
          [searchable]="true"
          [clearable]="true"
          [searchFn]="customSearchFn"
          style="width: 200px"
        >
          <ng-template ng-label-tmp let-item="item">
            {{ item.businessName | capitalize }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{ item.businessName | capitalize }}
          </ng-template>
        </ng-select>

        <div class="dropdown me-3">
          <select
            class="form-select"
            #statusSelect
            [(ngModel)]="status"
            (change)="loadDepartments(); setCurrentPage()"
          >
            <option value="" selected>Select Status</option>
            <option value="false">Active</option>
            <option value="true">Inactive</option>
          </select>
        </div>
        <div class="form-sort">
          <label>
            <input
              appTrimInput
              type="search"
              class="form-control"
              placeholder="Search"
              [(ngModel)]="search"
              (input)="loadDepartments()"
          /></label>
        </div>
        <!-- Rest of your template -->
      </div>
    </div>
    <div class="card-body p-0 mt-1">
      <div class="custom-datatable-filter table-responsive">
        <ng-container *ngIf="departments$ | async as departments">
          <table class="table datatable" *ngIf="departments.length > 0; else noRecords">
            <thead class="thead-light">
              <tr>
                <!-- <th class="no-sort"></th> -->
                <th>Department</th>
                <th>Business Entity</th>

                <th>Status</th>
                <th class="text-end">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let department of departments$ | async">
                <td>{{ department.departmentName }}</td>
                <!-- <td><span class="badge badge-soft-info">Promotion</span></td>
                  <td>Germany</td>
                  <td>
                    <div class="set-star">
                      <i class="fa fa-star filled me-2"></i>4.2
                    </div>
                  </td> -->
                <td>{{ department.business?.businessName || 'N/A' | capitalize }}</td>

                <td>
                  <span
                    *ngIf="!department.disabled"
                    class="badge badge-success d-inline-flex align-items-center badge-xs"
                  >
                    <i class="ti ti-point-filled me-1"></i>Active
                  </span>
                  <span
                    *ngIf="department.disabled"
                    class="badge badge-danger d-inline-flex align-items-center badge-xs"
                  >
                    <i class="ti ti-point-filled me-1"></i>Inactive
                  </span>
                </td>
                <td class="text-end">
                  <div class="action-icon d-inline-flex">
                    <!-- <a [routerLink]="[department.id]" class="me-2" ><i class="ti ti-eye"></i></a> -->
                    <a
                      *appHasPermission="{ department: ['edit'] }"
                      href="javascript:void(0);"
                      class="me-2"
                      (click)="openEditDepartment(addBusinessModals, department)"
                      ><i class="ti ti-edit"></i
                    ></a>
                    <ng-container *appHasPermission="{ department: ['edit'] }">
                      <a
                        href="javascript:void(0);"
                        class="me-2"
                        *ngIf="department.disabled"
                        (click)="openModal(false, department.id.toString())"
                      >
                        <i class="ti ti-lock"></i>
                      </a>
                      <a
                        href="javascript:void(0);"
                        *ngIf="!department.disabled"
                        (click)="openModal(true, department.id.toString())"
                      >
                        <i class="ti ti-lock-open-2"></i>
                      </a>
                    </ng-container>
                    <a
                      *appHasPermission="{ department: ['delete'] }"
                      href="javascript:void(0);"
                      (click)="openDeleteModal(department.id.toString())"
                      ><i class="ti ti-trash"></i
                    ></a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </ng-container>
        <ng-template #noRecords>
          <div class="text-center">Record not available</div>
        </ng-template>
      </div>
    </div>
    <!-- pagination -->
    <ng-container *ngIf="departments$ | async as departments">
      <div
        class="d-flex align-items-center justify-content-between ms-2"
        *ngIf="departments.length > 0"
      >
        <div>
          Showing {{ (currentPage - 1) * pageLimit + 1 }} to {{ pageLastRecord }} of
          {{ totalCount }} entries
        </div>
        <div class="has-text-centered mt-3">
          <app-pagination
            [currentPage]="currentPage"
            [pageSize]="pageLimit"
            [totalRows]="totalCount"
            (pageChange)="onPageChange($event)"
          ></app-pagination>
        </div>
      </div>
    </ng-container>

    <!-- pagination end -->
  </div>
</div>

<app-block-unblock
  *ngIf="showModal"
  [isBlocking]="isBlocking"
  [recordId]="blockDepartmentId"
></app-block-unblock>

<app-delete *ngIf="showDeleteModal" [recordId]="blockDepartmentId"></app-delete>

<ng-template #addBusinessModals let-modal>
  <!-- <div class="modal custom-modal fade custom-modal-two modal-padding" id="add_company" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content"> -->
  <div class="modal-header">
    <h5 class="modal-title">{{ title }} Department</h5>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="form">
      <div class="input-block mb-3">
        <label class="col-form-label" for="departmentName"
          >Department Name <span class="text-danger">*</span></label
        >
        <input
          class="form-control"
          type="text"
          formControlName="departmentName"
          appTrimInput
          minlength="3"
        />
        <div *ngIf="form.get('departmentName')?.invalid && form.get('departmentName')?.touched">
          <span class="text-danger">
            {{ getErrorMessage('departmentName') }}
          </span>
        </div>
      </div>
      <div class="input-block mb-3">
        <label class="col-form-label" for="businessId"
          >Business Entity <span class="text-danger">*</span></label
        >
        <!-- <select class="form-select" formControlName="businessId">
          <option disabled selected>Select Business Entity</option>
          <option
            *ngFor="let business of businesses$ | async"
            [value]="business.id"
            [attr.data-owner-id]="business.userId"
          >
            {{ business.businessName | capitalize }}
          </option>
        </select> -->
        <ng-select
          class="me-3 w-100"
          [items]="businesses$ | async"
          bindValue="id"
          placeholder="Select Business Entity"
          formControlName="businessId"
          [searchable]="true"
          [clearable]="true"
          [searchFn]="customSearchFn"
          style="width: 200px"
        >
          <ng-template ng-label-tmp let-item="item">
            {{ item.businessName | capitalize }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{ item.businessName | capitalize }}
          </ng-template>
        </ng-select>
        <div *ngIf="form.get('businessId')?.invalid && form.get('businessId')?.touched">
          <span class="text-danger">
            {{ getErrorMessage('businessId') }}
          </span>
        </div>
      </div>
      <!-- <div class="submit-section">
                  <button class="btn btn-primary submit-btn" (click)="onSubmit()" [disabled]="!form.valid">Submit</button>
                </div> -->
    </form>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-light border me-2"
      data-bs-dismiss="modal"
      (click)="onClose()"
    >
      Cancel
    </button>
    <button type="submit" class="btn btn-primary" (click)="onSubmit()" [disabled]="!form.valid">
      <ng-container *ngIf="isLoading$ | async; else loading">
        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        Save...
      </ng-container>
      <ng-template #loading> Save </ng-template>
    </button>
  </div>
  <!-- </div>
      </div>
    </div> -->
</ng-template>
